import React from 'react';
import { Col, Space } from 'antd';
import { useTranslation } from 'react-i18next';

import { TitleRow } from 'components/styledComponents';
import { StyledTitle } from 'components/StyledTitle';
import { Spinner, GenericResult, Markdown } from 'components';
import { useFaq } from 'hooks';

import { FaqDescriptions } from './components';

const FaqPage = (): JSX.Element => {
  const { t } = useTranslation();

  const { data, error } = useFaq();

  if (!data && !error) return <Spinner />;

  if (error) return <GenericResult />;

  return (
    <>
      <TitleRow align="middle" justify="space-between">
        <Col>
          <StyledTitle color="var(--text-color-secondary)" level={3}>
            {t('cms.faq.heading')}
          </StyledTitle>
        </Col>
      </TitleRow>

      <Space direction="vertical" size="middle">
        {data?.faq.map(({ question, answer }, index) => (
          <FaqDescriptions key={`${question}-${answer}-${index}`} column={1}>
            <FaqDescriptions.Item label={t('faq.marker.question', { index: index + 1 })}>
              <Markdown>{question}</Markdown>
            </FaqDescriptions.Item>

            <FaqDescriptions.Item label={t('faq.marker.answer', { index: index + 1 })}>
              <Markdown>{answer}</Markdown>
            </FaqDescriptions.Item>
          </FaqDescriptions>
        ))}
      </Space>
    </>
  );
};

export default FaqPage;
